import { clsx } from "clsx"
import { Heading } from "packages/basket-and-checkout/shared/components/Heading/Heading"
import { Text } from "packages/basket-and-checkout/shared/components/Text/Text"
import React from "react"
import { trackClicked } from "tracking/utils/trackClicked"
import type { CTAType } from "types"

import {
  headerWrapper,
  headerWrapperWithCTA,
  componentTitle,
  componentDescription,
  componentCTA,
} from "./BasketSectionsHeader.css"

type Props = {
  title?: string
  description?: string | null
  sectionType?: string
  wrapperClassName?: string
  cta?: CTAType
  onCtaClick?: () => void
}

export const BasketSectionsHeader: React.FC<Props> = ({
  title,
  description,
  cta,
  onCtaClick,
  sectionType = "section",
  wrapperClassName = "",
}) => {
  return (
    <div
      className={clsx(
        wrapperClassName,
        headerWrapper,
        cta && headerWrapperWithCTA
      )}
    >
      <Heading
        as="h2"
        variant="h3"
        className={componentTitle}
        data-testid={`${sectionType}-title`}
      >
        {title}
      </Heading>
      {cta?.text && onCtaClick && (
        <Text
          as="p"
          variant="copy"
          data-testid={`${sectionType}-cta`}
          className={componentCTA}
          onClick={() => {
            onCtaClick()
            trackClicked(cta.tracking?.clicked)
          }}
        >
          {cta.text}
        </Text>
      )}
      {description && (
        <Text
          as="p"
          variant="copy"
          className={componentDescription}
          data-testid={`${sectionType}-description`}
        >
          {description}
        </Text>
      )}
    </div>
  )
}
